export class InsuredDO {

    public guid: any = null;
    public insuredId: any = null;
    public roleCd: any = null;
    public insuredNameCd: any = null;
    public insuredGenderCd: any = null;
    public insuredDOB: any = null;
    public insuredMaritalStatusCd: any = null;
    public insuredHeightCd: any = null;
    public insuredWeightCd: any = null;
    public disease: any = null;
    public beneficiaryTypeCd: any = null;
    public beneficiarySubTypeCd: any = null;
    public beneficiaryName: any = null;
    public relationCd: any = null;
    public isPrimaryInsured: boolean = false;
    public insuredType: any = null;
    // public insuredMemberList = [{
    //     role: '',
    //     guid: 0
    // }];
    public insuredAddressList = []
    public insuredContactList = [];
    public insuredEmailList = [];
    public insuredIdentityList = [];
    public pedList = [];
    constructor() {

    }
}